const playlistsList = {
  "playlists.list.empty": "No playlists to display!",
  "playlists.list.save.error": "An error occurred while saving the playlist",
};

const playlistModal = {
  "playlists.playlist.finished.modal.title.improved": "Congratulations!",
  "playlists.playlist.finished.modal.title.completed": "Congratulations!",
  "playlists.playlist.finished.modal.title.failed": "Better luck next time!",
  "playlists.playlist.finished.modal.body.improved": "You completed the playlist and earned a new reward.",
  "playlists.playlist.finished.modal.body.completed": "You completed the playlist and earned the {{ reward }}.",
  "playlists.playlist.finished.modal.body.failed": "You did not complete the playlist this time.",
  "playlists.playlist.finished.modal.targets.title": "Reach the following targets to earn a better reward:",
  "playlists.playlist.finished.modal.targets.your-score": "Your score:",
  "playlists.playlist.finished.modal.targets.next-target": "Target for next reward:",
};

const playlistSection = {
  "playlists.section.view": "View",
  "playlists.section.join.short": "Join",
  "playlists.section.join.full": "Join Playlist",
};

const playlistStatus = {
  "playlists.playlist.status.label": "Status",
  "playlists.playlist.status.null": "Not Started",
  "playlists.playlist.status.not_started": "Not Started",
  "playlists.playlist.status.completed": "Completed",
  "playlists.playlist.status.failed": "Failed",
  "playlists.playlist.status.winner": "Winner",
};

const playlistsPage = {
  "playlists.page.title": "Playlists",
  "playlists.subheader.continue": "Continue",
  "playlists.subheader.categories": "Browse by Category",
  "playlists.subheader.drills": "Drill Playlists",
  "playlists.subheader.recently.played": "Recently Played",
  "playlists.view.playlist": "View Playlist",
  "playlists.subheader.featured": "Featured Playlists",
  "playlists.promo.caption": "Playlist of the Month",
  "playlists.latest.caption": "Latest Playlist",
  "playlists.fallback.career.caption": "Continue Career to advance to new leagues and unlock Playlists!",
  "playlists.categories.all": "All",
};

const playlistPage = {
  "playlist.scenarios.amount": "{{ count }} scenarios",
  "playlists.playlist.page.title": "Playlist",
  "playlists.playlist.list.header": "Playlists ({{ playlists }})",
  "playlists.playlist.page.join": "Join",
  "playlists.playlist.page.details": "Details",
  "playlists.playlist.page.scenarios": " scenarios",
  "playlists.playlist.page.has-ended": "This playlist has ended",
  "playlists.playlist.page.ends-in": "Ends in {{ time }}",
  "playlists.playlist.page.not-started": "This Playlist has not started yet",
  "playlists.playlist.page.current.score": "Your current score",
  "playlists.playlist.page.current.score.main.metric": "BYB IQ:",
  "playlists.playlist.page.rewards": "Rewards",
  "playlists.playlist.page.leaderboard.title": "Leaderboard",
  "playlists.playlist.page.leaderboard.top": "Leaderboard (Top {{ count }})",
  "playlists.playlist.page.leaderboard.join": "Join",
  "playlists.playlist.page.leaderboard.see-all": "See all",
  "playlists.playlist.page.leaderboard.no-data": "No players have completed this playlist yet",
  "playlists.playlist.page.description": "Description",
  "playlists.playlist.page.results.title": "Your Results",
  "playlists.playlist.page.results.see-all": "See all results",
  "playlists.playlist.page.create": "Create",
  "playlists.playlist.page.update": "Update",
  "playlists.playlist.page.no-scenarios": "No scenarios added",
};

const playlistSharingDialog = {
  "playlists.playlist.sharing.users": "Users",
  "playlists.playlist.sharing.teams": "Teams",
  "playlists.playlist.sharing.accounts": "Accounts",
  "playlists.playlist.sharing.filter-selected": "Filter selected",
  "playlists.playlist.sharing.previous": "Previous",
  "playlists.playlist.sharing.next": "Next",
  "playlists.playlist.sharing.page": "Page {{ page }} of {{ total }}",
  "playlists.playlist.sharing.share.title": "Share Playlist",
  "playlists.playlist.sharing.user.name": "User {{ name }}",
  "playlists.playlist.sharing.user.unknown": "Unknown User",
  "playlists.playlist.sharing.no.name": "No Name",
  "playlists.playlist.sharing.unknown": "Unknown",
  "playlists.playlist.sharing.group.name": "Group: {{ name }}",
  "playlists.playlist.sharing.no.group": "No Group",
  "playlists.playlist.sharing.members": "Members: {{ count }}",
};

const playlistScenarioSelectionDialog = {
  "playlists.playlist.selection.your.account": "Your Account",
  "playlists.playlist.selection.no.scenarios": "No scenarios found",
};

const playlistCategoryPage = {
  "playlists.category.page.latest.playlist": "Latest Playlist",
  "playlists.category.page.grid.title": "{{ count }} Playlists",
};

const playlistReward = {
  "playlist.results.header": "Results",
  "playlist.best.result": "Best Result",
  "playlist.results.see-all": "See all results",
  "playlist.performance.header": "Last Performance",
  "playlist.best.result.no.data": "No data available",
  "playlist.sessions.no-data": "No sessions available",
  "playlists.reward.target": "Target: {{ target }} {{ metric }}",
  "playlists.reward.place": "{{ place }} place",
  "playlists.reward.not.ranked": "Not ranked",
  "playlists.reward.achieved.on": "Earned on {{ date }}",
  "playlists.reward.not.achieved": "Not earned yet",
  "playlists.reward.scarcity": "Earned by {{ scarcity }}% of players who attempted this playlist",
  "playlists.reward.best.iq": "{{ iq }} BYB IQ",
  "playlists.reward.no.date.available": "Not available",
};

const playlistCard = {
  "playlists.card.locked.tooltip": "Advance in Career to unlock this Playlist",
  "playlists.card.starts-in": "Starts in {{ time }}",
  "playlists.card.ends-in": "Ends in {{ time }}",
  "playlists.card.has-ended": "Ended",
  "playlists.play-playlist": "Play Playlist",
};

const playlistFilter = {
  "playlists.filter.title": "Filter",
  "playlists.filter.not_started": "Not Started",
  "playlists.filter.completed": "Completed",
  "playlists.filter.failed": "Failed",
  "playlists.filter.locked": "Locked",
  "playlists.filter.clear": "Clear all",
  "playlists.filter.apply": "Apply filters ({{ count }})",
};

const playlistListItem = {
  "playlists.playlist.list.item.status.published": "Published",
  "playlists.playlist.list.item.status.draft": "Draft",
  "playlists.playlist.list.item.delete-confirmation.title": "Are you sure you want to delete the playlist {{ name }}?",
};

const playlistScenarioSelector = {
  "playlists.playlist.scenario.selector.tooltip": "Select scenarios to include in the playlist",
};

const playlistScenarioSettings = {
  "playlists.playlist.scenario.settings.title": "Game Settings",
  "playlists.playlist.scenario.settings.game-speed": "Game Speed",
  "playlists.playlist.scenario.settings.bullet-time": "Bullet Time",
  "playlists.playlist.scenario.settings.mirrored": "Mirrored",
  "playlists.playlist.scenario.settings.awareness.title": "Awareness Settings",
  "playlists.playlist.scenario.settings.awareness.player-count": "Player Count",
  "playlists.playlist.scenario.settings.awareness.time-limit": "Time Limit",
  "playlists.playlist.scenario.settings.awareness.distance": "Distance",
};

const customPlaylists = {
  "playlists.custom.name": "Name",
  "playlists.custom.start": "Start",
  "playlists.custom.end": "End",
  "playlists.custom.scenarios": "Scenarios",
  "playlists.custom.published": "Published",
  "playlists.custom.updated": "Updated",
  "playlists.custom.create": "Create Playlist",
  "playlists.custom.edit": "Edit Playlist",
};

export const playlists = {
  ...playlistsList,
  ...playlistModal,
  ...playlistSection,
  ...playlistsPage,
  ...playlistPage,
  ...playlistStatus,
  ...playlistSharingDialog,
  ...playlistScenarioSelectionDialog,
  ...playlistCategoryPage,
  ...playlistReward,
  ...playlistCard,
  ...playlistFilter,
  ...playlistListItem,
  ...playlistScenarioSelector,
  ...playlistScenarioSettings,
  ...customPlaylists,
};
